var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVelocityPointsIcon = function SvgVelocityPointsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1333.333 1333.333"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "VelocityPointsIcon_svg__a",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#VelocityPointsIcon_svg__a)",
    transform: "matrix(1.33333 0 0 -1.33333 0 1333.333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0-276.142-223.858-500-500-500s-500 223.858-500 500 223.858 500 500 500S0 276.142 0 0",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(1000 500)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-240.337 0-435.864-195.527-435.864-435.863 0-240.331 195.527-435.858 435.864-435.858s435.864 195.527 435.864 435.858C435.864-195.527 240.337 0 0 0m0-892.938c-252.032 0-457.08 205.042-457.08 457.075C-457.08-183.826-252.032 21.216 0 21.216s457.08-205.042 457.08-457.079c0-252.033-205.048-457.075-457.08-457.075",
    style: {
      fill: "#e10a0a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(500 935.862)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-121.73-330.321L-242.641 0h-110.634l184.717-452.919h92.787L108.083 0Z",
    style: {
      fill: "#e10a0a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(618.435 692.42)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-.011-.011c-.051-.084-.281-.421-.774-.897-1.245-1.2-4.076-3.168-9.464-3.538l9.543 33.545 5.752 20.297-5.708.14-28.471.768-17.634-12.077s-.448-.325-1.553-.97c-1.121-.661-2.371.634-1.693 1.739l9.498 15.356.045 3.791-9.173 15.463c-.662 1.122.611 2.4 1.721 1.71 1.077-.644 1.537-.975 1.537-.975l17.358-12.307 28.393.387 6.359.089-1.06 3.892-13.653 50.119c7.805-.645 10.171-4.57 10.171-4.57l6.941-10.815 14.774-22.898.998-1.587 8.618-13.372 21.928-.135c16.821-.112 20.347-7.67 20.347-7.67S71.1 47.983 54.28 48.09l-21.917.157-2.417-3.606z",
    style: {
      fill: "#e10a0a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(779.337 433.557)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v27.283L-508.449 12.94Z",
    style: {
      fill: "#e10a0a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(709.88 476.653)"
  })));
};
export default SvgVelocityPointsIcon;